import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";
import BooleanInput from "../../formElements/BooleanInput";
import ColorInput from "../../formElements/ColorInput";
import FreeTypeSelectInput from "../../formElements/FreeTypeSelectInput";

function ServiceCaseStateForm(props) {

    function formContent(data, update, updateCustom) {
        function getCategoryOptions() {
            let options = data.Kategoria_options
            if (options) {
                options = options.sort((a, b) => a.localeCompare(b))
            }
            return options ? ['', ...options] : []
        }

        function updateCategory(event) {
            let newData = {...data}
            newData['Kategoria'] = event.target.value
            updateCustom(newData)
        }
        return <>
            <StringInput name={'Stav'} label={'Stav'} value={data.Stav} onChange={update}/>
            <FreeTypeSelectInput options={getCategoryOptions()} name={'Kategoria'} label={'Kategória'} value={data.Kategoria} onChange={updateCategory}/>
            <BooleanInput name={'Uzavrety'} label={'Uzavretý'} value={data.Uzavrety} onChange={update}/>
            <div className="col-sm-offset-2 col-sm-1">
                <ColorInput name={'Farba'} label={'Farba'} value={data.Farba} onChange={update}/>
            </div>
        </>
    }

    return (
        <GenericForm label="Stav Servisného Prípadu"
                     labelNew="Pridať Stav Servisného Prípadu"
                     baseUrl='/service_case/service_cases_states/'
                     formContent={formContent}/>
    )

}

export default ServiceCaseStateForm
